/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Move_Items_TitleInputs */



/**
* | output |
* | --- |
* | "Move Items" |
*
* @param {Explorer_Nav_Move_Items_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_move_items_title = /** @type {((inputs?: Explorer_Nav_Move_Items_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Move_Items_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer des elements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gegenstände verschieben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta gli elementi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместить предметы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover elementos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移动物品")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アイテムを移動する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वस्तुओं को स्थानांतरित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mover itens")
	return /** @type {LocalizedString} */ ("Move Items")
});